import React, { useState } from 'react';
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import Section from '../../../shared/Section/Section';
import styles from './styles';
import ModalBlock from '../../../shared/ModalBlock/ModalBlock';
import ConsultationModal from '../../../shared/Modals/ConsultationModal';
// ‑

const formData = {
  title: 'Веб-разработчик',
  subtitle: 'Основная программа',
  sentContent: {
    title: 'Вы успешно записались на программу!',
  },
};

const leadData = {
  leadAction: 'Заявка на программу',
  leadBlock: 'Топ',
  leadPage: 'Веб_Разработка',
};

const ymSubmitEventType = 'WebDevTopConsultation';

function DevIntro() {
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [isRequestOpen, setIsRequestOpen] = useState(false);

  return (
    <Section
      theme="medium"
      bg="devintro"
      position={'right'}
      wrapperStyles={{ minHeight: { xs: 255, lg: 587 } }}
      customStyles={{
        borderRadius: { xs: '0px 0px 24px 24px', lg: 0 },
        overflow: 'hidden',
        mt: '-1px',
      }}
    >
      <Grid container sx={{ mt: { xs: 7, lg: 18 } }}>
        <Grid item xs={12} sm={7}>
          <Typography
            component={'h1'}
            variant={isMd ? 'mobileH1' : 'desktopHXXL'}
            color="kit.text.mainInverse"
            sx={{ mr: 'auto', maxWidth: { xs: 348, sm: 'none' } }}
            display={'flex'}
            flexWrap={'wrap'}
          >
            Веб-разработчик
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.linkWrapper}>
            <Button
              size="medium"
              variant="kitPrimary"
              onClick={() => setIsRequestOpen(true)}
            >
              Записаться
            </Button>
          </Box>
        </Grid>
      </Grid>
      <ModalBlock
        isOpen={isRequestOpen}
        handleClose={() => setIsRequestOpen(false)}
      >
        <ConsultationModal
          extraLeadData={leadData}
          formData={formData}
          ymSubmitEventTypes={[ymSubmitEventType]}
        />
      </ModalBlock>
    </Section>
  );
}

export default DevIntro;
